<div class="main-layout d-flex">
    <div class="sidebar shadow" [ngClass]="{'collapsed': collapsed}">
        <app-sidebar [companyNotifs]="companyNotifs"></app-sidebar>
    </div>
    <div class="content-wrapper">
        <div class="header">
            <app-header></app-header>
        </div>
        <div class="content-body" [ngClass]="{'expanded': collapsed}">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>

<app-company-new-order-dialog></app-company-new-order-dialog>

<p-toast></p-toast>
